import React from 'react';

const ICON_ID = 'icon-mountain';

const IconMountain = function(props) {
  return (
    <svg width="49" height="48" viewBox="0 0 49 48" aria-labelledby={ICON_ID}>
      <title id={ICON_ID}>Mountain Icon</title>
      <g strokeWidth="1.143" fill="none" fillRule="evenodd">
        <path d="M24.097.572c12.985 0 23.512 10.487 23.512 23.425S37.082 47.422 24.097 47.422C11.11 47.422.584 36.935.584 23.997S11.11.572 24.097.572z" strokeLinejoin="round"/>
        <path d="M10.903 31.032h26.426L27.051 13.323l-5.424 9.274L18.067 19z"/>
      </g>
    </svg>

  )
}

export default IconMountain;



// WEBPACK FOOTER //
// ./src/client/components/icons/icon-mountain.jsx